import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { COLORS } from "colors/color";
import Chat from "../../views/Chat/Chat";
import ListRecruiter from "../../views/admin/ListRecruiter";
import FormCustomizer from "views/Posts/FormCustomizer";
import AdminProfile from "views/admin/adminProfile";
import ExitToAppRoundedIcon from "@mui/icons-material/ExitToAppRounded";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpIcon from "@mui/icons-material/Help";
import myLogo from "../../assets/img/logo_.svg";
import logo from "../../assets/img/smart_logo_white2.svg";
import closet_icon from "../../assets/img/closet_icon_white.svg";
import closet_collapse_icon from "../../assets/img/closet_collapse_icon.svg";
import mySmallLogo from "../../assets/img/logo_small.svg";
import small_logo from "../../assets/img/small_smart.svg";
import settings_icon from "../../assets/img/settings_icon.svg";
import help_icon from "../../assets/img/help_icon.svg";
import logout_icon from "../../assets/img/logout_icon2.svg";
import x_icon from "../../assets/img/close_icon.svg";
import {
  Badge,
  Box,
  Divider,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import atob from "atob";
import { useTranslation } from "react-i18next";
import colors from "colors/color";
import NormalizedResume from "views/admin/normalizedResume";
const SidebarContainer = styled.div`
  width: ${({ $isSidebarCollapsed }) =>
    $isSidebarCollapsed ? "80px" : "270px"};
  background:  rgba(0, 23, 231);
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  z-index: 100;
  border-radius: 0px;
  transition: width 0.3s ease, left 0.3s ease;
  overflow: hidden;
  font-family: Poppins;
  border-right: 1px solid #d9d9d9;
  
  @media (max-width: 768px) {
    width: ${({ $isMobile, $isSidebarCollapsed }) => 
      $isMobile ? ($isSidebarCollapsed ? "80px" : "250px") : "0"};
    left: ${({ $isMobile }) => ($isMobile ? "0" : "-250px")};
    position: fixed;
    z-index: 1036;
  }
`;

const Logo = styled.div`
  padding: 10px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #ffff;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: ${({ $isSidebarCollapsed }) =>
      $isSidebarCollapsed ? "50px" : "80%"};
    transition: width 0.6s ease;
  }

  @media (max-width: 768px) {
    img {
      width: ${({ $isSidebarCollapsed }) =>
        $isSidebarCollapsed ? "20px" : "80%"};
    }
  }
`;

const NavContainer = styled.nav`
  padding: 10px 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
`;

const NavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: ${({ $isSidebarCollapsed }) =>
    $isSidebarCollapsed ? "center" : "flex-start"};
  width: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "100%" : "80%")};
  padding: 10px
    ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "0" : "20px")};
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin-bottom: 5px;
  gap: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "0" : "10px")};
  font-size: 14px;
  font-family: Poppins;
  font-weight: 600px;

  img {
    filter: brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(50%) contrast(50%);
  }

  &:hover {
    background-color: #f5f5ff;
    color: ${colors.primary};
    img {
      filter: brightness(0) saturate(100%) invert(13%) sepia(100%) saturate(2000%) hue-rotate(240deg) brightness(90%) contrast(95%);
    }
  }

  &.active {
    background-color: #fff;
    color: ${colors.primary};
    font-weight: 600;
    img {
      filter: brightness(0) saturate(100%) invert(13%) sepia(100%) saturate(2000%) hue-rotate(240deg) brightness(90%) contrast(95%);
    }
  }

  i {
    font-size: 15px;
    color: #fff;
    transition: color 0.3s ease;
  }

  &:hover i {
    color: ${colors.primary};
  }

  &.active i {
    color: ${colors.primary};
  }

  p {
    font-weight: 400;
    padding-left: 16px;
    margin: 0;
    font-size: 12px;
    display: ${({ $isSidebarCollapsed }) =>
      $isSidebarCollapsed ? "none" : "block"};
  }

  @media (max-width: 768px) {
    justify-content: ${({ $isSidebarCollapsed }) =>
      $isSidebarCollapsed ? "center" : "flex-start"};
    width: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "100%" : "80%")};
    padding: ${({ $isSidebarCollapsed }) => 
      $isSidebarCollapsed ? "12px 0" : "12px 20px"};
    gap: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "0" : "10px")};

    p {
      display: ${({ $isSidebarCollapsed }) =>
        $isSidebarCollapsed ? "none" : "block"};
      padding-left: ${({ $isSidebarCollapsed }) =>
        $isSidebarCollapsed ? "0" : "16px"};
    }
  }
`;

const SettingsItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ $isSidebarCollapsed }) =>
    $isSidebarCollapsed ? "center" : "flex-start"};
  width: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "100%" : "80%")};
  padding: 10px
    ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "0" : "20px")};
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin-bottom: 9px;
  margin-top: 18px;
  gap: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "0" : "10px")};
  font-size: 12px;
  font-family: Poppins;
  font-weight: 600px;
  cursor: pointer;
  &:hover {
    background-color:rgba(255, 2, 2, 0.93);
  }

  &.active {
    background-color: #d9d9d91a;
    color: ${colors.primary};
    font-weight: 600;
    i {
      color: #fff;
    }
  }

  i {
    font-size: 15px;
    color: #fff;
    transition: color 0.3s ease;
  }

  p {
    font-weight: 400;
    margin: 0;
    font-size: 12px;
    display: ${({ $isSidebarCollapsed }) =>
      $isSidebarCollapsed ? "none" : "block"};
  }

  @media (max-width: 768px) {
    justify-content: ${({ $isSidebarCollapsed }) =>
      $isSidebarCollapsed ? "center" : "flex-start"};
    width: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "100%" : "80%")};
    padding: ${({ $isSidebarCollapsed }) => 
      $isSidebarCollapsed ? "12px 0" : "12px 20px"};
    gap: ${({ $isSidebarCollapsed }) => ($isSidebarCollapsed ? "0" : "10px")};

    p {
      display: ${({ $isSidebarCollapsed }) =>
        $isSidebarCollapsed ? "none" : "block"};
    }
  }
`;

const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  margin-bottom: 0 !important;
`;

// New component for mobile toggle button that appears outside sidebar
const MobileToggleButton = styled.div`
  display: none;
  position: fixed;
  top: 10px;
  left: 10px;
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1035;
  @media (max-width: 768px) {
    display: ${({ $isMobile }) => ($isMobile ? "none" : "flex")};
  }
`;

const routes = [
  // {
  //   path: "/createRecruiter",
  //   name: "Create Recruiter",
  //   icon: "fas fa-user-plus",
  //   component: <createRecruiter />,
  //   layout: "/manager",
  // },
  {
    path: "/ListRecruiter",
    name: "List Recruiters", 
    icon: "fas fa-list",
    component: <ListRecruiter />,
    layout: "/manager",
  },
  {
    path: "/AdminProfile",
    name: "Admin Profile",
    icon: "fas fa-user",
    component: <AdminProfile />,
    layout: "/manager",
  },
  {
    path: "/AdminCompanyProfile",
    name: "Company Profile",
    icon: "fas fa-building",
    component: <AdminProfile />,
    layout: "/manager",
  },
  {
    path: "/candidature_spontanee",
    name: "Spontaneous Apply",
    icon: "fas fa-file-alt",
    component: <FormCustomizer />,
    layout: "/manager",
  },
  {
    path: "/Chat",
    name: "Chat",
    icon: "fas fa-comment",
    component: <settingsAdmin />,
    layout: "/manager",
  },
  {
    path: "/cv_normalised",
    name: "cv_normalised",
    icon: "fas fa-file-signature",
    component: <NormalizedResume />,
    layout: "/manager",
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "fas fa-cog",
    component: <settingsAdmin />,
    layout: "/manager",
  },
  {
    path: "/login",
    name: "Log Out",
    icon: "fas fa-sign-out-alt", // Use appropriate logout icon
    component: null, // No component needed for logout
    layout: "/logout", 
    isLogout: true, 
  },
];



function Sidebar({
  isSidebarCollapsed = false,
  isMobile = false,
  onClose,
  onToggleSidebar,
  setIsSidebarCollapsed,
  onOpen
}) {
  const { t } = useTranslation();
  const location = useLocation();
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(isSidebarCollapsed);
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // Update internal collapsed state when prop changes
  useEffect(() => {
    setCollapsed(isSidebarCollapsed);
  }, [isSidebarCollapsed]);

  useEffect(() => {
    if (isSmallScreen && !isMobile) {
      setCollapsed(false);
      if (setIsSidebarCollapsed) {
        setIsSidebarCollapsed(false);
      }
    }
  }, [isSmallScreen, setIsSidebarCollapsed]);

  const handleToggleSidebar = () => {
    const newCollapsedState = !collapsed;
    setCollapsed(newCollapsedState);
    if (setIsSidebarCollapsed) {
      setIsSidebarCollapsed(newCollapsedState);
    }

    // If parent provided onToggleSidebar, call it with new state
    if (onToggleSidebar) {
      onToggleSidebar(newCollapsedState);
    }
  };

  // Function to handle logout
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  };

  const handleSettings = () => {
    navigate("/manager/settings");
    if (isSmallScreen && isMobile) {
      onClose();
    }
  };

  const handleHelpCenter = () => {
    navigate("/manager/help");
    if (isSmallScreen && isMobile) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile toggle button outside sidebar */}
      <MobileToggleButton $isMobile={isMobile} onClick={onOpen}>
        <img
          src={small_logo}
          alt="Menu"
          style={{ width: "20px", height: "auto",
             filter: "brightness(0) saturate(100%) invert(100%)",
           }}
        />
      </MobileToggleButton>

      <SidebarContainer $isSidebarCollapsed={collapsed} $isMobile={isMobile}>
        {isMobile ? (
          <Box
            sx={{
              paddingTop: 2,
              paddingRight: 2,
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <img
              src={x_icon}
              onClick={onClose}
              alt="close"
              style={{ width: "14px", height: "auto", cursor: "pointer" }}
            />
          </Box>
        ) : null}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ padding: collapsed && isSmallScreen ? 1 : 2 }}
        >
          <Grid item>
            <Logo
              $isSidebarCollapsed={collapsed}
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              <img
                src={collapsed ? small_logo : logo}
                alt="TalentyHire Logo"
                style={{
                  objectFit: "contain",
                  width: collapsed ? "20px" : "124px",
                  height: "auto",
                }}
              />
            </Logo>
          </Grid>
          {isMobile ? null : (
            <Grid
              item
              sx={{ paddingRight: collapsed && isSmallScreen ? 0 : 2 }}
            >
              <img
                src={collapsed ? closet_collapse_icon : closet_icon}
                alt="Toggle sidebar"
                style={{
                   filter: "brightness(0) saturate(100%) invert(100%)",
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                  transition: "transform 0.3s ease",
                  marginLeft: collapsed ? (isSmallScreen ? 6 : 12) : 0,
                  marginTop: collapsed ? (isSmallScreen ? 6 : 12) : 0,
                }}
                onClick={handleToggleSidebar}
              />
            </Grid>
          )}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {collapsed ? (
            <Divider
              orientation="horizontal"
              sx={{
                borderTopWidth: 1,
                width: "50%",
                display: "flex",
                alignItems: "center",
              }}
            />
          ) : null}
        </Box>
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "14px",
            color: "#fff",
            paddingLeft: collapsed ? 1 : 3.5,
            paddingTop: 2,
            paddingBottom: 1,
            display: collapsed ? "none" : "block",
          }}
        >
          {t("adminProfile.admin_menu") || "Admin Menu"}
        </Typography>

        <NavContainer ref={sidebarRef}>
          {routes.map((route, index) => {
            // If it's a logout route, don't render it here
            if (route.isLogout) {
              return null;
            }

            // For regular routes, render as usual
            return (
              <NavItem
                key={index}
                to={route.layout + route.path}
                $isSidebarCollapsed={collapsed}
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={isMobile ? onClose : undefined}
              >
                <i className={route.icon} />
                <p>{t(`navbar.${route.name.toLowerCase().replace(/ /g, "_")}`) || route.name}</p>
              </NavItem>
            );
          })}
        </NavContainer>

        {collapsed ? (
          <Box sx={{ width: "100%", marginTop: "0px" }}>
            <Divider
              orientation="horizontal"
              sx={{
                borderTopWidth: 1,
                width: "50%",
                display: "flex",
                alignItems: "center",
                margin: "0px auto",
              }}
            />
          </Box>
        ) : null}

        <Box
          sx={{
            width: "100%",
          }}
        >
         <SettingsContainer>
            {/* Settings button 
            <SettingsItem
              $isSidebarCollapsed={collapsed}
              onClick={handleSettings}
            >
              <img 
                src={settings_icon} 
                alt="Settings"
                style={{ 
                  width: "18px", 
                  height: "18px" 
                }}
              />
              <p>{t("settings") || "Settings"}</p>
            </SettingsItem>

            <SettingsItem
              $isSidebarCollapsed={collapsed}
              onClick={handleHelpCenter}
            >
              <img 
                src={help_icon} 
                alt="Help" 
                style={{ 
                  width: "18px", 
                  height: "18px" 
                }} 
              />
              <p>{t("help_center") || "Help Center"}</p>
            </SettingsItem> */}

            {/* Logout button */}
            <SettingsItem
              $isSidebarCollapsed={collapsed}
              onClick={handleLogout}
              sx={{ color: "#fff" }}
            >
              <img
                src={logout_icon}
                alt="Logout"
                style={{
                   filter: "brightness(0) saturate(100%) invert(100%)",
                  width: "18px",
                  height: "18px",
                }}
              />
              <p style={{ color: "#fff" }}>{t("logout") || "Log Out"}</p>
            </SettingsItem>
          </SettingsContainer>
        </Box>
      </SidebarContainer>
    </>
  );
}

export default Sidebar;
